import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { callApi } from "../../services/ApiServices";
import { formatTimestampWithTime } from "../../utlis/function";
import CommonPagination from "../common/CommonPagination";
import { ImagePath } from "../common/ImagePath";

const TransactionHistory = () => {
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 5;
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      fetchTransactionHistory(currentPage, limit);
    }
  }, [id]);

  const fetchTransactionHistory = async (page, limit) => {
    try {
      const res = await callApi({
        method: "get",
        url: `admin/transaction-list/${id}?page=${page}&limit=${limit}`,
      });
      if (res.status === 200) {
        setTransactionHistory(res?.data);
        const totalRecords = res?.pagination?.total
        setTotalPages(Math.ceil(totalRecords/limit));
      }
    } catch (error) {
      console.log("error while fetching transaction history", error);
    }
  };

  const handlePageChange = (e) => {
    setCurrentPage(e);
    fetchTransactionHistory(e, limit);
  };

  return (
    <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
      <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
        Transaction History
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#fafafa] border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-base font-medium text-black">
                Date & Time
              </th>
              <th className="px-6 py-3 text-left text-base font-medium text-black">
                Transaction ID
               </th>
             {/* <th className="px-6 py-3 text-left text-base font-medium text-black">
                Club/Resort Name
              </th> */}
              <th className="px-6 py-3 text-left text-base font-medium text-black">
                Amount
              </th>
              <th className="px-6 py-3 text-left text-base font-medium text-black">
                Payment Method
              </th>
              <th className="px-6 py-3 text-left text-base font-medium text-black">
              Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {transactionHistory?.length > 0 ? (
              transactionHistory?.map((transaction, index) => (
                <tr
                  key={transaction?.id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-4 text-sm font-normal text-textcolor whitespace-nowrap">
                    {formatTimestampWithTime(transaction?.createdAt)}
                  </td>
                  <td className="px-6 py-4 text-sm font-normal text-textcolor">
                    {transaction?.id ? transaction?.id : ""}
                  </td>
                  {/* <td className="px-6 py-4 text-sm font-normal text-textcolor">
                    {transaction?.clubResort}
                  </td> */}
                  <td className="px-6 py-4 text-sm font-normal text-textcolor">
                    {transaction?.amount ? `$${transaction?.amount}` : "$0.00"}
                  </td>
                  <td className="px-6 py-4 text-sm font-normal text-textcolor">
                    {transaction?.card
                      ? `${transaction?.card?.charAt(0).toUpperCase() + transaction?.card?.slice(1)} ***** ${transaction?.cardLast4}`
                      : "-"}
                  </td>
                  <td className="px-6 py-4 text-sm font-normal text-textcolor">
                      {transaction?.transactionStatus ? transaction?.transactionStatus?.charAt(0).toUpperCase() + transaction?.transactionStatus?.slice(1).toLowerCase(): "-"}
                  </td>
                </tr>
              ))
            ) : (
             <tr>
                  <td colSpan={5} className="px-6 py-10 text-center">
                    <div className="flex justify-center items-center">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-lg mt-2">No Data found</p>
                  </td>
                </tr>
            )}
          </tbody>
        </table>
      </div>
      <CommonPagination
        pageCount={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TransactionHistory;
